<template>
  <div>
    <vx-card class="mb-10">
      <div class="relative">
        <div>
          <vs-button @click="goBack" color="primary" type="filled"
          >Back</vs-button
        >
         
          <input
            type="checkbox"
            v-model="allSelected"
            style="float:right;"
            @click="selectAll"
          />

          <template class="ml-10">

            
            <vs-button
              type="filled"
              style="float:right; margin-right: 50px;"
              @click="acceptSelected"
              >Proceed</vs-button
            >
          </template>

        
        </div>
      </div>
    </vx-card>
    <vx-card>
      <div class="text-center p-5">
        <h4>{{ 'Total : ' +  match_contacts.length }} </h4> 

      </div>

      <template v-for="(matched_contact, key) in match_contacts">
        <vs-table stripe :data="matched_contact" class="mb-20">
          <template slot="header">
            <h3 class="pb-5">Match {{ key + 1 }}</h3>
            <h3 class="pb-5">
              Confidence

              {{ parseFloat(matched_contact.slave.score).toFixed(2) }} {{ "%" }}
            </h3>


            <input
              type="checkbox"
              v-model="selected"
              @click="select"
              :value="{
                uuid: matched_contact.contact_id,
                slave_id: matched_contact.slave.ml_id,
                account_id: matched_contact.slave.account_id
              }"
            />
            <!-- <vs-checkbox
              v-model="selected"
              :vs-value="{'uuid':matched_contact.id,'slave_id':matched_contact.slave.ml_id}"
            ></vs-checkbox> -->
          </template>

          <template slot="thead">
            <vs-th v-if="matched_contact.slave.ml_company">Company</vs-th>
            <vs-th v-if="matched_contact.slave.ml_title">Title</vs-th
              >
            <vs-th v-if="matched_contact.slave.ml_forename">Forename</vs-th
            >
            <vs-th v-if="matched_contact.slave.ml_surname">Surname</vs-th
              >
              <vs-th v-if="matched_contact.slave.ml_job_title">Job Title</vs-th
                >
                <vs-th v-if="matched_contact.slave.ml_email">Email</vs-th
                  >
                  <vs-th v-if="matched_contact.slave.ml_mobile">Mobile</vs-th
                    >
                    <vs-th v-if="matched_contact.slave.ml_ddi">DDI</vs-th
                      >
                      <vs-th v-if="matched_contact.slave.ml_social_media">Social Media</vs-th
                        >
                        <vs-th v-if="matched_contact.slave.ml_seniority">Seniority</vs-th
                          >
                          <vs-th v-if="matched_contact.slave.ml_role">Role</vs-th
                            >
                            <vs-th v-if="matched_contact.slave.ml_sub_role">Sub Role</vs-th
                              >
                     
         
          
          </template>

          <template slot-scope="{ data }">
            <vs-tr>
            
              <vs-td v-if="matched_contact.slave.ml_company">
                {{ matched_contact.company_name }}
              </vs-td>
              <vs-td v-if="matched_contact.slave.ml_title">
                {{ matched_contact.contact_title }}
              </vs-td>
              <vs-td v-if="matched_contact.slave.ml_forename">
                {{ matched_contact.contact_forename }}
              </vs-td>
              <vs-td v-if="matched_contact.slave.ml_surname">
                {{ matched_contact.contact_surname }}
              </vs-td>
              <vs-td v-if="matched_contact.slave.ml_job_title">
                {{ matched_contact.contact_job_title }}
              </vs-td>
              <vs-td v-if="matched_contact.slave.ml_email">
                {{ matched_contact.contact_email }}
              </vs-td>
              <vs-td v-if="matched_contact.slave.ml_mobile">
                {{ matched_contact.contact_mobile }}
              </vs-td>
              <vs-td v-if="matched_contact.slave.ml_ddi">
                {{ matched_contact.contact_ddi }}
              </vs-td>
              <vs-td v-if="matched_contact.slave.ml_social_media">
                {{ matched_contact.contact_social_media }}
              </vs-td>
              <vs-td v-if="matched_contact.slave.ml_seniority">
                {{ matched_contact.contact_seniority }}
              </vs-td>
              <vs-td v-if="matched_contact.slave.ml_role">
                {{ matched_contact.contact_role }}
              </vs-td>
              <vs-td v-if="matched_contact.slave.ml_sub_role">
                {{ matched_contact.contact_sub_role }}
              </vs-td>
            
            </vs-tr>



            <vs-tr>
              <vs-th v-if="matched_contact.slave.ml_company">Company</vs-th>
              <vs-th v-if="matched_contact.slave.ml_title">Title</vs-th
                >
              <vs-th v-if="matched_contact.slave.ml_forename"
                >Forename</vs-th
              >
              <vs-th v-if="matched_contact.slave.ml_surname"
              >Surname</vs-th
            >
            <vs-th v-if="matched_contact.slave.ml_job_title">Job Title</vs-th
              >
              <vs-th v-if="matched_contact.slave.ml_email">Email</vs-th
                >
                <vs-th v-if="matched_contact.slave.ml_mobile">Mobile</vs-th
                  >
                  <vs-th v-if="matched_contact.slave.ml_ddi">DDI</vs-th
                    >
                    <vs-th v-if="matched_contact.slave.ml_social_media">Social Media</vs-th
                      >
                      <vs-th v-if="matched_contact.slave.ml_seniority">Seniority</vs-th
                        >
                        <vs-th v-if="matched_contact.slave.ml_role">Role</vs-th
                          >
                          <vs-th v-if="matched_contact.slave.ml_sub_role">Sub Role</vs-th
                            >
            </vs-tr>



            <vs-tr>
              <vs-td v-if="matched_contact.slave.ml_company">
                {{ matched_contact.slave.ml_company }}
              </vs-td>
              <vs-td v-if="matched_contact.slave.ml_title">
                {{ matched_contact.slave.ml_title }}
              </vs-td>
              <vs-td v-if="matched_contact.slave.ml_forename">
                {{ matched_contact.slave.ml_forename }}
              </vs-td>
              <vs-td v-if="matched_contact.slave.ml_surname">
                {{ matched_contact.slave.ml_surname }}
              </vs-td>
            <vs-td v-if="matched_contact.slave.ml_job_title">
            {{ matched_contact.slave.ml_job_title }}
            </vs-td>
            <vs-td v-if="matched_contact.slave.ml_email">
            {{ matched_contact.slave.ml_email }}
            </vs-td>
            <vs-td v-if="matched_contact.slave.ml_mobile">
            {{ matched_contact.slave.ml_mobile }}
            </vs-td>
            <vs-td v-if="matched_contact.slave.ml_ddi">
            {{ matched_contact.slave.ml_ddi }}
            </vs-td>
            <vs-td v-if="matched_contact.slave.ml_social_media">
            {{ matched_contact.slave.ml_social_media }}
            </vs-td>
            <vs-td v-if="matched_contact.slave.ml_seniority">
            {{ matched_contact.slave.ml_seniority }}
            </vs-td>
            <vs-td v-if="matched_contact.slave.ml_role">
            {{ matched_contact.slave.ml_role }}
            </vs-td>
            <vs-td v-if="matched_contact.slave.ml_sub_role">
            {{ matched_contact.slave.ml_sub_role }}
            </vs-td>
              <vs-td> </vs-td>
              <vs-td> </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </template>
    </vx-card>
 
  </div>
</template>

<script>
import defineAbilitiesFor from '@/config/abilities'
import ImportExcel from "@/components/excel/ImportExcel.vue";
import draggable from "vuedraggable";
import Prism from "vue-prism-component";
import vSelect from "vue-select";
import axios from "@/axios.js";
import _ from "lodash";
import ProgressBar from 'vue-simple-progress'
// import MatchResults from "@/components/Match.vue"
export default {
  components: {
    ImportExcel,
    draggable,
    Prism,
    vSelect,
    ProgressBar

  },
  data() {
    return {
      PLeasewait: '',
      uploadPercentage: 0,
      active1:false,
      selected_campaign: {},
      abilities : null,
      table_name_exists: null,
      upload_validation: false,
      upload_validation_message: null,
      file_name: null,
      table_name: null,
      csv_filename: null,
      match_ten_context: [],
      validation_message: "",
      total_pages: 0,
      limit: 10,
      currentx: 1,
      fieldgroups: [
        {
          dbfield: "",
          count: 0,
          uploadfield: [],
          selection: true
        }
      ],
      allSelected: false,
      selected: [],
      count: 0,
      match_contacts: [],
      showImportWidget: true,
      tableData: [],
      header: [],
      sheetName: "",
      csv_table_fields: [],
      uploaded_columns: [],
      accept_text: "Accept",
      acceptButtonColor: "primary",
   
    };
  },
  mounted() {
    this.getColumnsFromCSVTable()
    this.getMatchedField()
  },
  watch: {
 
  },
  methods: {
    goBack: function() {
      this.$router.go(-1);
    },
    acceptSelected() {
      this.$vs.loading();



      let self = this;
      let selected_data = {};
      selected_data.selected = this.selected;
      selected_data.table_name = this.$route.params.table_name;
      selected_data.campaign_id = this.$route.params.campaignId;
      
      axios
        .post(
          this.$base_url + "/api/contacts/save_matched_contact",
          selected_data
        )
        .then(response => {
          if (response.data.status == "success") {

            self.$router.replace("/contacts/unmatched/" + self.$route.params.campaignId);
            self.$vs.loading.close();
          }else{


            let notUpdatedData = response.data.data


            this.$vs.dialog({
              color: "primary",
              title: `Import Contact To Campaign`,
              text: " You accepted " + notUpdatedData.no_of_accepted + " machine learning matched contacts, however only " + notUpdatedData.no_of_updated + " were imported to the campaign.  Please contact support to get this issue rectified before proceeding with the contact import process.  Do not close this window. The following matched contacts were not successfully added to the campaign: ",
              accept: this.acceptAlert
            });

             console.log("Not updated" , response.data.data)

            self.$vs.loading.close();
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    acceptAlert() {
      return
    },
    getColumnsFromCSVTable(){
      let self = this
      let data = {};
      data.campaign_id = this.$route.params.campaignId
      data.level = 'contacts'
      axios
        .post(
          this.$base_url + "/api/contacts/get_columns_from_table",
          data
        )
        .then(response => {
            let result = JSON.parse(response.data.selected_field)


            console.log("Columns" , result)


            result.forEach(function(ele){
              self.csv_table_fields.push({
                id: ele.id,
                label :  ele.name,
                name: ele.name
            })
        })
        }).catch(error => {
            console.log(error);
          });
    },
    ucFirstAllWords(str) {
      var pieces = str.split(" ");
      for (var i = 0; i < pieces.length; i++) {
        var j = pieces[i].charAt(0).toUpperCase();
        pieces[i] = j + pieces[i].substr(1);
      }
      return pieces.join(" ");
    },
    formatUploadedHeader(s) {
      if (typeof s !== "string") return "";
      s = s.replace("_", " ");
      s = s.replace("_", " ");
      s = s.replace("slave", " ");
      s = s.replace("master", " ");
      s = s.replace("_", " ");
      s = s.replace("ml", " ");
      s = s.replace("_", " ");
      return this.ucFirstAllWords(s);
    },
    addAnother: function() {
      this.fieldgroups.push({
        dbfield: "",
        uploadfield: [],
        count: ++this.count
      });
    },
    deleteColumn(slot) {
      console.log(this.fieldgroups);
      this.fieldgroups = this.fieldgroups.filter(function(ele) {
        return ele != slot;
      });
      console.log(slot);
      // this.fieldgroups.pop(slot);
    },

    removeDuplicates(myArr, prop) {
      return myArr.filter((obj, pos, arr) => {
        return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
      });
    },
    selectAll() {


      let matches = this.match_contacts;




      

      

      if (this.allSelected) {
        matches.forEach(match => {
          this.selected.pop({ uuid: match.contact_id, slave_id: match.slave.ml_id , account_id: match.slave.account_id });
        });
      } else {

        matches.forEach(match => {
          this.selected.push({ uuid: match.contact_id, slave_id: match.slave.ml_id , account_id: match.slave.account_id });
        });
   
      }




    },
    select() {
      this.allSelected = false;
     
    },
    getMatchedField() {
      let self = this
      this.$vs.loading();
      let data = {}
      data.table_name = this.$route.params.table_name;
      data.campaign_id = this.$route.params.campaignId;
      axios
        .post(
          this.$base_url + "/api/contacts/get_ml_matched_contacts",
          data )
        .then(response => {
      
            if (response.data === undefined || response.data.data.length == 0) {
              this.$vs.notify({
                color: "primary",
                title: "Import Contact",
                text:
                  "No record matches has been found. Please upload other files that contains matched contacts."
              });
              self.$router.replace("/contacts/unmatched/" + this.$route.params.campaignId);
              // this.showMatches = false;
              // this.showImportWidget = true;
            } else {
              this.match_contacts = response.data.data;
              // this.selected = this.removeDuplicates(this.selected, "uuid");
            }
            this.$vs.loading.close();
        })
        .catch(error => {
          console.log(error);
        });
    },
  },
    created(){
     var self = this
     this.table_name = 'data_build_' + this.$route.params.campaignId.replaceAll("-" , "_") + '_contacts'
    defineAbilitiesFor().then(function(data){
      self.abilities = data
    });  
  }
};
</script>
<style scoped>
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table
  .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}

.center-span {
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}
</style>
